import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/figmaColors'

export const useStyles = makeStyles()(theme => ({
  root: {
    boxSizing: 'border-box',
    width: '100%',
    display: 'flex',
    gap: 32,
    alignItems: 'flex-start',
  },
  leftColumn: {
    flex: '1 1 0',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
  },
  rightColumn: {
    width: 308,
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
  },
  card: {
    boxSizing: 'border-box',
    width: '100%',
    backgroundColor: C.cardBg,
    borderRadius: 8,
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    width: '100%',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    minWidth: 0,
  },
  headerTitleGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    minWidth: 0,
  },
  iconBox: {
    width: 28,
    height: 28,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: C.iconBoxBg,
    borderRadius: 4,
    '& svg': { fontSize: 16, color: C.strongText },
  },
  cardTitle: {
    fontSize: 18,
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: C.strongText,
    margin: 0,
  },
  helpIcon: {
    flexShrink: 0,
    fontSize: 16,
    color: C.mutedText,
  },
  collapseButton: {
    flexShrink: 0,
    width: 24,
    height: 24,
    padding: 0,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: C.mutedText,
    '& svg': { fontSize: 16 },
  },
  inputWrap: {
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  fieldRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  textField: {
    boxSizing: 'border-box',
    width: 302,
    maxWidth: '100%',
    height: 44,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '10px 16px',
    border: `1px solid ${C.buttonBorder}`,
    borderRadius: 4,
    backgroundColor: C.cardBg,
  },
  input: {
    flex: '1 1 auto',
    minWidth: 0,
    border: 'none',
    outline: 'none',
    background: 'none',
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: C.darkText,
    '&::placeholder': { color: C.mutedText },
  },
  inputInfoIcon: {
    flexShrink: 0,
    fontSize: 16,
    color: C.mutedText,
  },
  // Amber link inside the payee tooltip (Figma 343-6814).
  tooltipLink: {
    color: C.tooltipLink,
    textDecoration: 'none',
    wordBreak: 'break-all',
    '&:hover': { textDecoration: 'underline' },
  },
  textFieldError: {
    borderColor: theme.palette.error.main,
  },
  helperText: {
    paddingLeft: 16,
    fontSize: 12,
    lineHeight: '16px',
    color: C.mutedText,
  },
  helperTextError: {
    color: theme.palette.error.main,
  },
  savedBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 12,
    lineHeight: '16px',
    color: theme.palette.success.main,
  },
  automationBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    width: '100%',
  },
  automationRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    width: '100%',
  },
  rowMain: {
    flex: '1 1 0',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  rowLabelLine: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  rowLabel: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: C.darkText,
  },
  rowInfoIcon: {
    fontSize: 16,
    color: C.mutedText,
  },
  rowDescription: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: C.mutedText,
  },
  rowCriteriaAside: {
    paddingLeft: 24,
    fontSize: 14,
    fontWeight: 400,
    fontStyle: 'italic',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: C.mutedText,
  },
  rowAsideIcon: {
    marginRight: 6,
    fontSize: 14,
    verticalAlign: -1,
  },
  supportLink: {
    color: C.linkBlue,
    fontWeight: 500,
    textDecoration: 'none',
  },
  rowDivider: {
    width: '100%',
    height: 1,
    borderRadius: 4,
    backgroundColor: C.divider,
  },
  sideCard: {
    boxSizing: 'border-box',
    width: '100%',
    backgroundColor: C.cardBg,
    borderRadius: 8,
    padding: 32,
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
  },
  sideCardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    width: '100%',
  },
  sideCardTitle: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: C.strongText,
    margin: 0,
  },
  auditEmpty: {
    flex: '1 1 auto',
    minHeight: 150,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  auditWatermark: {
    width: 112.921,
    height: 87,
    opacity: 0.18,
  },
  auditScrollWrap: {
    position: 'relative',
    width: '100%',
  },
  auditList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%',
    maxHeight: 190,
    overflowY: 'auto',
  },
  auditItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    width: '100%',
  },
  auditItemText: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: C.darkText,
  },
  auditItemTime: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    color: C.mutedText,
  },
  auditDivider: {
    display: 'block',
    width: '100%',
    height: 1,
    backgroundColor: C.divider,
  },
  notificationsBody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 12,
    padding: '0 12px',
    width: '100%',
  },
  notificationsText: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: C.darkText,
    textAlign: 'center',
  },
  notificationsButton: {
    boxSizing: 'border-box',
    height: 40,
    padding: '10px 24px',
    border: `1px solid ${C.stepUpcomingBorder}`,
    borderRadius: 4,
    backgroundColor: C.cardBg,
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: C.strongText,
  },
}))
